import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { StyledRow } from 'components/styles/CommonStyles';

import { useTranslation } from '@hooks';
import { CookiePartnerDetail } from '@components/common';
import {
    ArrowBottomIcon,
    ToggleActive,
    TogglePassive,
} from '@components/icons';
import { Caption2, Text2 } from '@components/styles/Typography';

const CookiePartner = ({
    title,
    partnerPreferences,
    setPartnerPreferences,
}) => {
    const { t } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    useEffect(() => {
        setPartnerPreferences({ ...partnerPreferences, [title]: isChecked });
    }, [isChecked]);

    return (
        <Partner>
            <StyledRow>
                <Text2 uppercase>{title}</Text2>
                <div>
                    <label htmlFor={title}>
                        {isChecked ? <ToggleActive /> : <TogglePassive />}
                    </label>
                    <input
                        id={title}
                        type="checkbox"
                        onChange={() => setIsChecked(!isChecked)}
                    />
                </div>
            </StyledRow>
            <button onClick={() => setShowDetail(!showDetail)} type="button">
                <Caption2>{t('details')}</Caption2>
                <ArrowBottomIcon />
            </button>
            {showDetail && (
                <CookiePartnerDetail
                    facebook={title === 'facebook'}
                    pixel={title === 'facebook pixel'}
                    gAnalytics={title === 'Google Analytics'}
                    gTagManager={title === 'Google Tag Manager'}
                    gReMarketing={title === 'Google Remarketing Tag'}
                />
            )}
        </Partner>
    );
};
const Partner = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;

    input {
        display: none;
    }
    button {
        align-self: flex-end;
        background-color: transparent;
        border: none;
    }
`;

export default CookiePartner;
